import { LucideIcon } from 'lucide-react'

import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const EmptyState = ({
  icon: Icon,
  title,
  children,
  className,
}: {
  icon: LucideIcon
  title: string
  children?: ReactNode
  className?: string
}) => (
  <div className={cn('flex flex-col items-center justify-center gap-2 p-8 text-center', className)}>
    <div className="grid size-12 place-items-center rounded-full bg-fill text-muted-foreground">
      <Icon className="size-6" />
    </div>
    <p className="text-heading-md text-ink">{title}</p>
    {children && <div className="max-w-xs text-sm text-muted-foreground">{children}</div>}
  </div>
)
